export const STATES_PREDETERMINATED_TEXT = {
    ACTIVE: "621fdce7e1b7dfa85f10bf48",
    DELETED: "621fdcd7e1b7dfa85f10bf46",
}